import { ActionTypes as actions } from '../actions';

const initialState = {
  appointmentsDict: null,             // Key Value object where keys are _id  of appointment
  practiceAppointmentIds: null,       // Array of all Practice Upcoming Appointment Ids
  practiceAllAppointmentIds: null,    // Array of all Practice Appointment Ids
  userAppointmentIds: null,           // Array of all User Upcoming Appointment Ids
  userAllAppointmentIds: null,        // Array of all User Appointment Ids
  consultationAppointmentsDict: null, // Key Value object where keys are consultation_ids and value is array of apt ids
}

export default function ScheduleReducer(state=initialState, action) {

  switch(action.type) {
    case actions.SCHEDULE_ADD_APT_TO_DICT:
      let appointments = state.appointmentsDict ? Object.assign({}, state.appointmentsDict) : {};
      let appointmentToAdd = action.payload;
      appointments[appointmentToAdd._id] = appointmentToAdd;
      state = { ...state, appointmentsDict: appointments };
      break;
    case actions.SCHEDULE_UPDATE_PRACTICE_APT_IDS:
      state = { ...state, practiceAppointmentIds: action.payload };
      break;
    case actions.SCHEDULE_ADD_PRACTICE_APT_ID:
      let practice_apt_ids = state.practiceAppointmentIds || [];
      let apt_id_to_add    = action.payload;
      practice_apt_ids.push(apt_id_to_add);
      state = { ...state, practiceAppointmentIds: practice_apt_ids };
      break;
    case actions.SCHEDULE_UPDATE_PRACTICE_ALL_APT_IDS:
      state = { ...state, practiceAllAppointmentIds: action.payload };
      break;
    case actions.SCHEDULE_ADD_PRACTICE_ALL_APT_ID:
      let practice_apt_all_ids = state.practiceAllAppointmentIds || [];
      let apt_id_to_add_to_all = action.payload;
      practice_apt_all_ids.push(apt_id_to_add_to_all);
      state = { ...state, practiceAllAppointmentIds: practice_apt_all_ids };
      break;
    case actions.SCHEDULE_UPDATE_USER_APT_IDS:
      state = { ...state, userAppointmentIds: action.payload };
      break;
    case actions.SCHEDULE_ADD_USER_APT_ID:
      let user_apt_ids = state.userAppointmentIds || [];
      let user_apt_id_to_add = action.payload;
      user_apt_ids.push(user_apt_id_to_add);
      state = { ...state, userAppointmentIds: user_apt_ids };
      break;
    case actions.SCHEDULE_UPDATE_USER_ALL_APT_IDS:
      state = { ...state, userAllAppointmentIds: action.payload };
      break;
    case actions.SCHEDULE_ADD_USER_ALL_APT_ID:
      let user_apt_all_ids = state.userAllAppointmentIds || [];
      let user_apt_id_to_add_to_all = action.payload;
      user_apt_all_ids.push(user_apt_id_to_add_to_all);
      state = { ...state, userAllAppointmentIds: user_apt_all_ids };
      break;
    case actions.USER_SIGN_OUT:
      state = initialState;
      break;
    default:

  }

  return state;
}
